export enum WCCSliderAutoScrollMode {
    disabled = 0,
    single = 1,
    loop = 2
}